import * as ActionTypes from './ActionTypes'
import * as constants from './Constants'
import { history } from '../helpers/history'

export const reducer = (
  state = {
    clubs: [],
    branches: [],
    productLevels: [],
    timezones: [],
    club: {},
    branch: {},
    productDetailTemplate: {},
    products: [],
    parentClubs: {},
    locations: [],
    costAdjustments: [],
    product: {},
    location: {},
    costAdjustment: {},
    productHistory: [],
    settings: {},
    promoCodes: [],
    promoCode: {},
    updateResult: '',
    responseRefund: '',
    currentUser: null,
    isAuthenticated: false,
    userReponse: null,
    validateSecureCodeReponse: null,
    currentNavigationSelect: null,
    recipient: {},
    resendEmailRecipientResponse: null,
    resendEmailSaleResponse: null,
    sendToRouterResponse: null,
    redemptionCodes: {},
    redemptionGroups: {},
  },
  action
) => {
  switch (action.type) {
    case ActionTypes.getClubs:
      return { ...state, clubs: action.payload }

    case ActionTypes.getAllClubs:
      return { ...state, clubs: action.payload }

    case ActionTypes.getTimeZones:
      return { ...state, timezones: action.payload }

    case ActionTypes.getSettings:
      return { ...state, settings: action.payload }

    case ActionTypes.getBranches:
      return { ...state, branches: action.payload }
      
    case ActionTypes.getProductLevels:
      return { ...state, productLevels: action.payload }

    case ActionTypes.getProductDetailTemplate:
      return { ...state, productDetailTemplate: action.payload }

    case ActionTypes.getLocations:
      return { ...state, locations: action.payload }

    case ActionTypes.getCostAdjustments:
      return { ...state, costAdjustments: action.payload }

    case ActionTypes.getClub:
      console.log(action.payload)
      return { ...state, club: action.payload }

    case ActionTypes.getProductHistoryById:
      console.log(action.payload)
      return { ...state, productHistory: action.payload }

    case ActionTypes.updateProductHistory:
      return { ...state, productHistory: action.payload }

    case ActionTypes.getSale:
      console.log(action.payload)
      return { ...state, sale: action.payload }

    case ActionTypes.getSales:
      return { ...state, sales: action.payload }

    case ActionTypes.getBranch:
      return { ...state, branch: action.payload }

    case ActionTypes.getProduct:
      return { ...state, product: action.payload }

    case ActionTypes.getLocation:
      return { ...state, location: action.payload }

    case ActionTypes.getCostAdjustment:
      return { ...state, costAdjustment: action.payload }

    case ActionTypes.updateClub:
      return { ...state, club: action.payload }

    case ActionTypes.updateResponse:
      return { ...state, updateResult: action.payload }

    case ActionTypes.updateBranch:
      return { ...state, branch: action.payload }

    case ActionTypes.updateProduct:
      return { ...state, product: action.payload }

    case ActionTypes.updateLocation:
      return { ...state, location: action.payload }

    case ActionTypes.updateCostAdjustment:
      return { ...state, costAdjustment: action.payload }

    case ActionTypes.createClub:
      state.clubs.push(action.payload)
      return state

    case ActionTypes.createBranch:
      return { ...state, branches: action.payload }

    case ActionTypes.createProduct:
      return { ...state, products: action.payload }

    case ActionTypes.createLocation:
      return { ...state, location: action.payload }

    case ActionTypes.createCostAdjustment:
      return { ...state, costAdjustment: action.payload }

    case ActionTypes.createBranch:
      state.branches.push(action.payload)
      return state

    case ActionTypes.userAuthentication:
      sessionStorage.setItem(constants.tokenName, JSON.stringify(action.payload.data))
      if (window.location.pathname === '/') {
        history.push('/secure/gifts')
      }
      return { ...state, currentUser: action.payload, isAuthenticated: true }

    case ActionTypes.logOut:
      return { ...state, currentUser: null, isAuthenticated: false, clubs: [], branches: [] }

    case ActionTypes.silentLogOut:
      return { ...state, currentUser: null, isAuthenticated: true }

    case ActionTypes.authenticationResponse:
      let isAuthenticated = false
      if (action.payload.data) isAuthenticated = action.payload.data.success
      return { ...state, currentUser: action.payload, isAuthenticated }

    case ActionTypes.setAuthentication:
      return { ...state, isAuthenticated: action.payload }

    case ActionTypes.setUnauthenticate:
      return { ...state, isAuthenticated: action.payload }

    case ActionTypes.userResponse:
      return { ...state, userReponse: action.payload }

    case ActionTypes.forgotPassword:
      return { ...state, userReponse: action.payload }

    case ActionTypes.validateSecureCode:
      return { ...state, validateSecureCodeReponse: action.payload }

    case ActionTypes.confirmChangePassword:
      return { ...state, userReponse: action.payload }

    case ActionTypes.currentNavigation:
      return { ...state, currentNavigationSelect: action.payload }

    case ActionTypes.getEnrollmentUrl:
      var newList = state.clubs.map(club => {
        if (club.clubId === action.payload.clubId) {
          club.url = action.payload.url
        }

        return club
      })

      return { ...state, clubs: newList }

    case ActionTypes.addCharge:
      var newList = state.clubs.map(club => {
        if (club.clubId === action.payload.clubId) {
          club.charge = action.payload.charge
          club.charge.amount = action.payload.amount
        }

        return club
      })

      return { ...state, clubs: newList }

    case ActionTypes.addRefund:
      return { ...state, updateRefund: action.payload }

    case ActionTypes.resendEmailRecipient:
      return { ...state, resendEmailRecipientResponse: action.payload }

      case ActionTypes.resendEmailSale:
      return { ...state, resendEmailSaleResponse: action.payload }

    case ActionTypes.updateRefund:
      return { ...state, responseRefund: action.payload }
    case ActionTypes.sendToRouter:
      return { ...state, sendToRouterResponse: action.payload }
    case ActionTypes.getPromoCode:
      return { ...state, promoCode: action.payload }

    case ActionTypes.getRedemptionCodes:
      return { ...state, redemptionCodes: action.payload }

    case ActionTypes.getRedemptionGroups:
      return { ...state, redemptionGroups: action.payload }

    default:
      return state
  }
}
